<!-- <div class="pos-product-sales-report-container col-md-12 no-padding mt-20">
    <div id="posproductsalesreport" *ngIf="isShowReport">
        <div class="row no-margin">
            <div class="col-md-12 no-padding">
                <div id="icons-container" class="row float-right">
                    <div class="col-md-12 no-padding">
                        <div class="col-md-3 right-padding-0">
                            <span (click)="addToFavorite()">
                                <i class="fa-heart-o fa pointer icon-heart"
                                    title="{{'reports.Add to Favorite' |translate |translateKey }}"></i>
                            </span>
                        </div>
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile(printType)" (click)="exportFile(printType)"
                                class="iconButtons" [disabled]="isAllProductSaleReportsLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="printIconUrl" alt="{{'customer-service.Print' |translate |translateKey }}"
                                        title="{{'customer-service.Print' |translate |translateKey }}" />
                                </span>
                            </button>
                        </div>        
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile(csvType)" (click)="exportFile(csvType)"
                                class="iconButtons" [disabled]="isAllProductSaleReportsLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="excelIconUrl"
                                        alt="{{'reports.Export CSV' |translate |translateKey}}"
                                        title="{{'reports.Export CSV' |translate |translateKey}}" />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 no-padding mt-10 mb-10">
            <div class="table-responsive">
                <table class="table table-hover table-striped custab">
                    <thead>
                        <tr>
                            <th class="cursor-pointer">{{'customer-service.Item #' | translate | translateKey}}&nbsp;</th>
                            <th class="cursor-pointer">{{'customer-service.Name' | translate | translateKey}}&nbsp;</th>
                            <th class="cursor-pointer">{{'customer-service.Total Sales' | translate | translateKey}}&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody
                        *ngIf="!isLoading && reportResponse && reportResponse.length > 0">
                        <tr
                            *ngFor="let report of reportResponse | paginate: {  id: 'pos-reports-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                            <td>{{report.itemNumber}}</td>
                            <td>{{report.productName}}</td>
                            <td>{{report.totalSales}}</td>
                        </tr>
                    </tbody>
                    <tbody
                        *ngIf="(reportResponse && reportResponse.length === 0 && !isLoading)  || (isResponseError && !isLoading)">
                        <tr>
                            <td colspan="12" class="text-center ">{{'customer-service.No record(s) found' |translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="12" class="text-center">{{'customer-service.Loading Results, Please wait.'|translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-5 paddingbot-20"
                *ngIf="reportResponse && reportResponse.length > 0">
                <span>{{pageCount}} {{'customer-service.record(s) found' |translate |translateKey}}</span>
                <pagination-controls id="pos-reports-pagination" (pageChange)="pageChange($event)" class="pull-right">
                </pagination-controls>
            </div>
        </div>
        <div class="col-xs-12 left-padding-0 right-padding-0 paddingbottom-10">
            <div class="col-xs-1 left-padding-0 right-padding-0">
                <select class="form-control per-page-width" id="currentPageSize" [(ngModel)]="pageSize"
                    [disabled]="!(reportResponse && reportResponse.length > 0)"
                    (change)="pageSizeChange($event.target.value)" name="currentPageSize" #currentPageSize="ngModel">
                    <option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</option>
                </select>
            </div>
        </div>
    </div>
</div>
 -->
 <div class="row w-100 no-margin message paddingtop-20"
    *ngIf="(reportResponse && reportResponse.length === 0 && !isLoading)  || (isResponseError && !isLoading)">
    <div class="w-100 messageContent text-center">
        <strong class="">{{'customer-service.No record(s) found' |translate | translateKey}}.</strong>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/pos-product-sales-report.component.html